export const weekly2Monthly = (weeklyVal) => {
  return weeklyVal * 30.4 / 7;
};

export const weekly2MonthlyInt = (weeklyVal) => {
  return Math.round(weekly2Monthly(weeklyVal));
};
